import React from 'react';

const Form = ({ children, formId, onSubmit, disabled, cssClasses }) => {
  return (
    <form
      id={formId}
      onSubmit={e => {
        onSubmit(e);
      }}
      autoComplete="off"
      className={`${cssClasses}`}>
      <fieldset disabled={disabled} className="if" style={{ border: 'none' }}>
        <div className="max-width">{children}</div>
      </fieldset>
    </form>
  );
};

export default Form;
